import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-custom-error-text',
    templateUrl: './custom-error-text.component.html',
    styleUrls: ['./custom-error-text.component.scss'],
    standalone: false
})
export class CustomErrorTextComponent implements OnInit {

  @Input('errors') errors: string[] | null = null;
  @Input('highlightWarn') highlightWarn: boolean = false;

  errorClasses: string = "mat-body-2";
  
  constructor() {}

  ngOnInit(): void {
    this.errorClasses = (this.highlightWarn) ? "mat-caption warn-text" : "mat-body-2";
  }

}
